/** A severidade de um alerta ou ressalva de leitura automática. */
export type Severidade = 'ALTA' | 'MEDIA' | 'BAIXA'

/** A ordem de leitura: o que pode mudar glosa ou decisão vem antes. */
const PESO: Record<Severidade, number> = { ALTA: 0, MEDIA: 1, BAIXA: 2 }

/**
 * Os itens do mais grave para o menos grave, estável dentro de cada grau.
 *
 * Mora fora do componente porque um arquivo de componente que exporta função quebra a recarga
 * rápida do Vite — e porque a ordem é regra de leitura, não de desenho.
 *
 * @param itens qualquer lista com `severidade`
 * @returns uma cópia ordenada
 */
export function porSeveridade<T extends { severidade: string }>(itens: readonly T[]): T[] {
  return [...itens].sort(
    (a, b) => (PESO[a.severidade as Severidade] ?? 1) - (PESO[b.severidade as Severidade] ?? 1),
  )
}
